import { getI18nProperties } from '@/store/utils/labels'
import paymentMethodsConf from '@/configuration/sources/smartform/paymentMethodsConf.yml'

export function initSmartformMethods() {
  const obj = {}
  ;['ALL', ...paymentMethodsConf.whitelist].forEach(method => {
    const applePayConfig = method === 'APPLE_PAY' ? { domainName: null } : {}
    obj[method] = {
      icon: null,
      label: getI18nProperties(null),
      displayPaymentReceipt:
        paymentMethodsConf.displayPaymentReceipt?.[method] ?? null, // null represents default behavior, true, false
      ...applePayConfig
    }
  })
  return obj
}
